import './index.css'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

// 1. Import React Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 2. Create the Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes (No refetching on back button)
      cacheTime: 1000 * 60 * 30, // Keep unused data in memory for 30 minutes
      refetchOnWindowFocus: false, // Don't refetch just because I clicked a different tab
    },
  },
});

ReactDOM.render(
  <React.StrictMode> 
    <Router>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);


